const styles = theme => ({
  title: {
    color: '#424242',
    overflowWrap: 'break-word',
  },
})

export default styles
